<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Calculadora de pessoas"
            description="Quantidade de pessoas por idade e equipes de saúde"
            url="/gestao-cadastros"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  metaInfo: {
    title: 'Calculadora de Pessoas',
    titleTemplate: null,
  },
  data() {
    return {}
  },
}
</script>

<style></style>
